/**
 * Costruisce href cliccabili per campi entità (email, telefono, sito, social, maps).
 * Usato da InlineEditableField / EditableInfoRow in tutto il CRM.
 */

export function buildEmailHref(email?: string | null): string | undefined {
  return email?.trim() ? `mailto:${email.trim()}` : undefined;
}

export function buildPhoneHref(phone?: string | null): string | undefined {
  return phone?.trim() ? `tel:${phone.trim().replace(/\s/g, '')}` : undefined;
}

export function normalizeWebsite(website?: string | null): string | undefined {
  if (!website?.trim()) return undefined;
  const trimmed = website.trim();
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
}

export function buildWebsiteHref(website?: string | null): string | undefined {
  return normalizeWebsite(website);
}

export function normalizeSocial(url?: string | null): string | undefined {
  if (!url?.trim()) return undefined;
  const trimmed = url.trim();
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
}

export function buildSocialHref(url?: string | null): string | undefined {
  return normalizeSocial(url);
}

export function buildMapsHref(address?: string | null): string | undefined {
  return address?.trim()
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address.trim())}`
    : undefined;
}
